import { Box, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import {
  ButtonPrimary,
  ButtonSecondary,
} from "../../../shared/components/button/Buttons";
import TextInput from "../../../shared/components/TextInput";
import { CrossIconSvg } from "../../../assets/icons/CrossIconSvg";
import { toastError, toastSuccess } from "../../../utils/ToastMessage";
import { useGlobalContext } from "../../../App";
import { updateStudioContent } from "../../../services/studioContent";
import Dropzone, { DropzoneRef } from "react-dropzone";
import { ImageIconSvg } from "../../../assets/icons/ImageIconSvg";
import { uploadDocument } from "../../../services/component";

type Props = {
  activeDialog: any;
  handleDialog?: any;
  handleRefreshData: any;
};

const AddFeaturedProjectPopup: React.FC<Props> = (props: Props) => {
  const { studioContentData } = useGlobalContext();
  const dropZoneRef = useRef<DropzoneRef | null>(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState<string | File>("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  // error states
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    link: "",
    imageUrl: "",
  });

  const validateFields = () => {
    let isValid = true;
    const newErrors: any = {
      title: "",
      description: "",
      link: "",
      imageUrl: "",
    };

    if (!title.trim()) {
      newErrors.title = "Title is required";
      isValid = false;
    }
    if (!description.trim()) {
      newErrors.description = "Description is required";
      isValid = false;
    }
    if (!link.trim()) {
      newErrors.link = "Link is required";
      isValid = false;
    }
    if (!imageUrl) {
      newErrors.imageUrl = "Image is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleAddFeaturedProject = async () => {
    if (!validateFields()) return;

    try {
      setLoading(true);
      let uploadedUrl = "";

      if (imageUrl) {
        const res: any = await uploadDocument(imageUrl);
        uploadedUrl = res?.data?.[0]?.url || "";
      }

      const data = {
        addedProject: { title, description, link, imageUrl: uploadedUrl },
        studioContentId: studioContentData?._id || "",
        isAddingStudioProject: true,
      };
      await updateStudioContent(data);
      toastSuccess("Success", "Project saved successfully:");
      props?.handleRefreshData();
      props?.handleDialog();
    } catch (error) {
      toastError("Error", "Error saving data:");
      console.error("Error saving data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeThumbnail = (files: File[]) => {
    if (files && files.length > 0) {
      setImageUrl(files[0]); // store selected file
      setErrors((prev) => ({ ...prev, imageUrl: "" }));
    }
  };

  return (
    props?.activeDialog && (
      <>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.60)",
            zIndex: 5000,
          }}
        >
          <Box
            sx={{
              width: "100vw",
              height: "100vh",
              border: "1px solid red",
              bgcolor: "rgba(0, 0, 0, 0.60)",
              filter: "blur(62px)",
            }}
          />
        </Box>

        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 6000,
          }}
        >
          <Box
            sx={{
              width: "1000px",
              padding: "24px",
              // minHeight: "270px",
              height: "auto",
              bgcolor: "#1B1B1B",
              borderRadius: "14px",
              border: "1px solid #3D3D3D",
              cursor: "default",
              position: "relative",
            }}
          >
            {/* Dialog content */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                gap: "24px",
              }}
            >
              {/* Title section */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    lineHeight: "28px",
                    fontWeight: "600",
                    color: "#FFFFFF",
                  }}
                >
                  {`Add Featured Project`}
                </Typography>
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    props?.handleDialog();
                  }}
                  sx={{
                    position: "absolute",
                    right: "20px",
                    top: "20px",
                    cursor: "pointer",
                    color: "white",
                  }}
                >
                  <CrossIconSvg color="white" width="20" height="20" />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "32px",
                  // border: "1px solid red",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    gap: "24px",
                    justifyContent: "space-between",
                    // alignItems: "center",
                    // border: "1px solid red",
                  }}
                >
                  {/* -------Description container------- */}
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      flex: 1.5,
                      gap: "12px",
                      // border: "1px solid red",
                    }}
                  >
                    <Box>
                      <TextInput
                        style={{ flex: 1 }}
                        label="Title"
                        lableStyles={{
                          fontSize: "16px !important",
                          fontWeight: "600",
                          lineHeight: "22px",
                        }}
                        placeholder="Enter title..."
                        type="text"
                        inputStyles={{
                          borderRadius: "14px !important",
                          height: "54px",
                          fontSize: "16px",
                          fontWeight: "400",
                          padding: "16px",
                          color: "#FFFFFF",
                        }}
                        value={title}
                        onChange={(e: any) => {
                          setTitle(e.target.value);
                          setErrors((prev) => ({ ...prev, title: "" }));
                        }}
                      />

                      {errors?.title && (
                        <Typography
                          className="err_field"
                          id="createProductTitlebNotExist"
                          color="#E25454"
                          variant="body2"
                        >
                          {errors.title}
                        </Typography>
                      )}
                    </Box>
                    <Box>
                      <TextInput
                        style={{ flex: 1 }}
                        label="Description"
                        lableStyles={{
                          fontSize: "16px !important",
                          fontWeight: "600",
                          lineHeight: "22px",
                        }}
                        placeholder="Enter description..."
                        type="text"
                        inputStyles={{
                          borderRadius: "14px !important",
                          height: "54px",
                          fontSize: "16px",
                          fontWeight: "400",
                          padding: "16px",
                          color: "#FFFFFF",
                        }}
                        value={description}
                        onChange={(e: any) => {
                          setDescription(e.target.value);
                          setErrors((prev) => ({ ...prev, description: "" }));
                        }}
                      />
                      {errors.description && (
                        <Typography
                          className="err_field"
                          id="createProductTitlebNotExist"
                          color="#E25454"
                          variant="body2"
                        >
                          {errors.description}
                        </Typography>
                      )}
                    </Box>
                    <Box>
                      <TextInput
                        style={{ flex: 1 }}
                        label="Link"
                        lableStyles={{
                          fontSize: "16px !important",
                          fontWeight: "600",
                          lineHeight: "22px",
                        }}
                        placeholder="Enter link..."
                        type="text"
                        inputStyles={{
                          borderRadius: "14px !important",
                          height: "54px",
                          fontSize: "16px",
                          fontWeight: "400",
                          padding: "16px",
                          color: "#FFFFFF",
                        }}
                        value={link}
                        onChange={(e: any) => {
                          setLink(e.target.value);
                          setErrors((prev) => ({ ...prev, link: "" }));
                        }}
                      />
                      {errors.link && (
                        <Typography
                          className="err_field"
                          id="createProductTitlebNotExist"
                          color="#E25454"
                          variant="body2"
                        >
                          {errors.link}
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* imageUrl */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      gap: "24px",
                      // border: "1px solid red",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        flex: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ color: "text.secondary" }}
                      >
                        Image
                      </Typography>

                      <Box
                        sx={{
                          // flex: 1,
                          borderRadius: "14px",
                          border: "2px dashed #3D3D3D",
                          bgcolor: "rgba(255, 255, 255, 0.06)",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          // width: "168px",
                          // height: "168px",
                          width: "100%",
                          height: "100%",
                          position: "relative",
                          cursor:"pointer"
                        }}
                      >
                        {imageUrl ? (
                          <Box
                            sx={{
                              width: "100%",
                              height: "100%",
                              backgroundImage:
                                imageUrl instanceof File
                                  ? `url(${URL.createObjectURL(imageUrl)})`
                                  : `url(${imageUrl})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                              borderRadius: "14px",
                              position: "relative",
                              "&:hover .overlay": {
                                opacity: 1,
                              },
                            }}
                          >
                            <Box
                              className="overlay"
                              sx={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                opacity: 0,
                                transition: "opacity 0.3s ease",
                                borderRadius: "14px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "12px",
                                  gap: "9px",
                                  position: "absolute",
                                  right: "0px",
                                  top: "0px",
                                }}
                              >
                                <Box
                                  onClick={() => setImageUrl("")}
                                  sx={{
                                    width: "24px",
                                    height: "24px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "75px",
                                    backgroundColor: "#E25454",
                                    cursor: "pointer",
                                  }}
                                >
                                  <CrossIconSvg color="white" />
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <Dropzone
                            accept={{
                              "image/png": [".png"],
                              "image/jpeg": [".jpeg", ".jpg"],
                            }}
                            ref={dropZoneRef}
                            disabled={false}
                            multiple={true}
                            onDrop={(acceptedFiles) =>
                              handleChangeThumbnail(acceptedFiles)
                            }
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  flex: 1,
                                }}
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "4px",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                >
                                  <ImageIconSvg />
                                  <Typography
                                    sx={{ color: "text.secondary", mt: "10px" }}
                                    variant="subtitle1"
                                  >
                                    Choose Files
                                  </Typography>
                                  <Typography
                                    sx={{
                                      maxWidth: "70%",
                                      textAlign: "center",
                                    }}
                                    color={"rgba(255, 255, 255, 0.5)"}
                                    variant="body2"
                                  >
                                    24x24px size required in PNG
                                  </Typography>
                                </Box>
                              </div>
                            )}
                          </Dropzone>
                        )}
                      </Box>
                      {errors.imageUrl && (
                        <Typography
                          className="err_field"
                          id="createProductTitlebNotExist"
                          color="#E25454"
                          variant="body2"
                        >
                          {errors.imageUrl}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                {/* -------Action buttons container------- */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    width: "218px",
                  }}
                >
                  <ButtonSecondary
                    sx={{
                      height: "46px",
                      width: "100%",
                      background: "transparent",
                      borderRadius: "14px",
                      padding: "15px 23.5px",
                    }}
                    onClick={() => {
                      props?.handleDialog();
                    }}
                    LabelStyle={{
                      fontSize: "18px !important",
                      fontWeight: "600",
                      lineHeight: "22px",
                    }}
                    label="Cancel"
                  />
                  <ButtonPrimary
                    isLoading={loading}
                    sx={{
                      height: "46px !important",
                      width: "100%",
                      padding: "15px 32px",
                      border: "1px solid #3D3D3D",
                    }}
                    onClick={handleAddFeaturedProject}
                    LabelStyle={{
                      fontSize: "18px !important",
                      fontWeight: "600",
                      lineHeight: "22px",
                    }}
                    label={"Save"}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    )
  );
};

export default AddFeaturedProjectPopup;
